import Axios from 'axios';
import { ICountry } from '@/domain/ICountry';
import { IToplevel } from '@/domain/IToplevel';
import store from '../store';
import config from '../../config.js';
import i18n from '@/i18n';
import { IWebContentsRequest, IWebContentsResponce } from '@/domain/IWebContents';
import { IBpTransactionsRequest, IBpTransactionsResponce } from '@/domain/IBpTransactions';

export abstract class BaseApi {
    private static axios = Axios.create({
        baseURL: config.API_URL,
        headers: {
            common: {
                'Content-Type': 'application/json'
            }
        }
    });

    static async getCountry(): Promise<ICountry[] | null> {
        const url = '/country?lang=' + i18n.locale;
        const encodedToken = store.state.token;
        const mydata = { countries: [] };
        try {
            const response = await this.axios.get<typeof mydata>(url, { headers: { 'Authentication-Estravel': 'Bearer ' + encodedToken } });
            if (response.status === 200) {
                return response.data.countries;
            }
            return null;
        } catch (error) {
            console.error('error: ', (error as Error).message);
            return null;
        }
    }

    static async getToplevel(): Promise<IToplevel[] | null> {
        const url = '/toplevel?lang=' + i18n.locale;
        const encodedToken = store.state.token;
        const mydata = { toplevels: [] };
        try {
            const response = await this.axios.get<typeof mydata>(url, { headers: { 'Authentication-Estravel': 'Bearer ' + encodedToken } });
            if (response.status === 200) {
                return response.data.toplevels;
            }
            return null;
        } catch (error) {
            console.error('error: ', (error as Error).message);
            return null;
        }
    }

    static async getWebContents(WebContentsRequest: IWebContentsRequest): Promise<IWebContentsResponce | null> {
        let url = '/getwebcontents?lang=' + i18n.locale + '&customerid=' + WebContentsRequest.customerid;
        if (WebContentsRequest.customer_type !== '') {
            url += '&customer_type=' + WebContentsRequest.customer_type;
        }
        if (WebContentsRequest.categories.length > 0) {
            url += '&categories=';
            WebContentsRequest.categories.forEach((cat, index) => {
                url += cat.category_id;
                if (index < WebContentsRequest.categories.length - 1) {
                    url += ',';
                }
            });
        }

        const encodedToken = store.state.token;
        const mydata = {
            favourites: null,
            offers: null,
            links: null,
            blocks: null
        };
        try {
            const response = await this.axios.get<typeof mydata>(url, { headers: { 'Authentication-Estravel': 'Bearer ' + encodedToken } });
            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('error: ', (error as Error).message);
            return null;
        }
    }

    static async getBpTransactions(BpTransactionsRequest: IBpTransactionsRequest): Promise<IBpTransactionsResponce | null> {
        const url =
            '/bp_transactions?lang=' +
            i18n.locale +
            '&customerid=' +
            BpTransactionsRequest.customerid +
            '&date_from=' +
            BpTransactionsRequest.date_from +
            '&date_to=' +
            BpTransactionsRequest.date_to;

        const encodedToken = store.state.token;
        const mydata = {
            initial_amount: null,
            final_amount: null,
            transactions: null
        };
        try {
            const response = await this.axios.get<typeof mydata>(url, { headers: { 'Authentication-Estravel': 'Bearer ' + encodedToken } });

            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('error: ', (error as Error).message);
            return null;
        }
    }
}
